import "core-js/stable/array/for-each";
import "core-js/stable/array/some";
import "core-js/stable/array/map";
import "core-js/stable/object/keys";

import "productlist.css";

import Vue from 'vue';

const vm = new Vue({
    el: '#app',
    components: {
        productlist: () => import('Productlist')
    }
});
